import { iappApiV1 } from '~/shared/services/api';
import { Campaign } from '~/shared/types/Campaign';
import { Pagination } from '~/shared/types/utils';

export async function fetchOpenCalendars() {
  const response = await iappApiV1.get<{
    pagination: Pagination;
    data: Campaign[];
  }>(`calendar`, {
    params: {
      onlyCurrentMonth: true,
      status: 'open'
    }
  });

  return response.data;
}
